module.exports = __webpack_public_path__ + "static/img/1587_jh716nzy.47da76c.png";


//////////////////
// WEBPACK FOOTER
// ./static/1587_jh716nzy.png
// module id = 29O2
// module chunks = 0